import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  TextField,
} from '@mui/material'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import { get } from 'lodash'
import Grid from '@mui/material/Grid'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import { getAddress } from 'src/services/buyPolicyService'
import { useDispatch } from 'react-redux'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { ERROR_ON_STATE_AND_CITY } from 'src/utils/constants/BuyPolicy'

const AddressForm = ({
  form,
  addressLabel,
  addressKey,
  handleIsPermanentAddressCheck,
  isCurrentAddressPermanent,
  isCurrentAddressForm = false,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { values } = form

  const getAddressFieldValue = (fieldKey) => {
    return get(values, `${addressKey}.${fieldKey}`)
  }

  const isAddressFieldError = (fieldKey) => {
    return isFormControlError(form, `${addressKey}.${fieldKey}`)
  }

  const getAddressFieldErrorText = (fieldKey) => {
    return getFormControlErrorText(form, `${addressKey}.${fieldKey}`)
  }

  const handleAddressFieldChange = (event) => {
    const { name, value } = event?.target
    form.setFormValue(`${addressKey}.${name}`, value, true)
  }

  const fetchFullAddress = async (pincode) => {
    const response = await getAddress(pincode)
    try {
      if (response?.res?.status !== 200) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      const responseData = response?.res?.data
      if (responseData) {
        // const city = responseData[0].PostOffice[0].Division
        // const state = responseData[0].PostOffice[0].State
        // let updatedAddress = {
        //   ...proposerDetails.address,
        //   [addressType]: {
        //     ...proposerDetails.address[addressType],
        //     city,
        //     state,
        //     pincode,
        //   },
        // };
        //
        // if (isPermanentAddress) {
        //   updatedAddress = {
        //     ...updatedAddress,
        //     permanentAddress: updatedAddress.currentAddress,
        //   };
        // }
        //
        // setProposerDetails({
        //   ...proposerDetails,
        //   address: {
        //     ...updatedAddress,
        //   },
        // }); future development
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_STATE_AND_CITY,
        })
      )
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.addressHeadingContainer}>
        <div className={classes.addressHeadingContent}>
          <span className={classes.addressHeading}>{addressLabel}</span>
        </div>
        {isCurrentAddressForm ? (
          <div>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    id='checkBox'
                    size='small'
                    checked={isCurrentAddressPermanent}
                    onChange={handleIsPermanentAddressCheck}
                  />
                }
                label='Permanent Address'
                className={classes.addressHeading}
              />
            </FormGroup>
          </div>
        ) : null}
      </div>

      <div className={classes.addressFormContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={8}>
            <FormControl fullWidth>
              <TextField
                id='addressLine'
                name='addressLine'
                type='text'
                placeholder='Flat/House no, Street *'
                required
                error={isAddressFieldError('addressLine')}
                helperText={getAddressFieldErrorText('addressLine')}
                value={getAddressFieldValue('addressLine')}
                onChange={handleAddressFieldChange}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='landmark'
                type='text'
                name='landmark'
                placeholder='Landmark'
                error={isAddressFieldError('landmark')}
                helperText={getAddressFieldErrorText('landmark')}
                value={getAddressFieldValue('landmark')}
                onChange={handleAddressFieldChange}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='pincode'
                type='number'
                name='pincode'
                placeholder='Pincode *'
                required
                error={isAddressFieldError('pincode')}
                helperText={getAddressFieldErrorText('pincode')}
                value={getAddressFieldValue('pincode')}
                onChange={async (event) => {
                  event.target.value = Math.max(
                    0,
                    parseInt(event?.target?.value)
                  )
                    ?.toString()
                    ?.slice(0, 6)
                  handleAddressFieldChange(event)
                  if (event?.target?.value?.length === 6) {
                    await fetchFullAddress(event?.target?.value)
                  }
                }}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='city'
                type='text'
                name='city'
                placeholder='City *'
                required
                error={isAddressFieldError('city')}
                helperText={getAddressFieldErrorText('city')}
                value={getAddressFieldValue('city')}
                onChange={handleAddressFieldChange}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='state'
                type='text'
                name='state'
                placeholder='State *'
                required
                error={isAddressFieldError('state')}
                helperText={getAddressFieldErrorText('state')}
                value={getAddressFieldValue('state')}
                onChange={handleAddressFieldChange}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default AddressForm

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  addressHeadingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  addressHeadingContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addressHeading: {
    fontSize: '16px',
    color: '#29AACD',
    fontWeight: '600',
  },
})
